// CENTRALIZED COLOR CONFIGURATION
// Change colors here and they'll update across the entire app!

export const colors = {
  // Backgrounds
  bgPage: '#FEFDF8',           // Warm cream/ivory
  bgCard: '#F5F3ED',           // Light warm beige
  bgAccent: '#FFF5EB',         // Soft peach cream
  bgGradient: 'linear-gradient(135deg, #FFE5D0 0%, #FFDDB8 50%, #FFC9EA 100%)',
  
  // Text
  textPrimary: '#2C2823',      // Deep warm charcoal
  textSecondary: '#6B6560',    // Warm gray
  textMuted: '#9B8F88',        // Light warm gray
  textInverse: '#FFFFFF',      // Pure white
  
  // Brand Colors (Main accent color)
  brandPrimary: '#E85D35',     // Warm coral/orange
  brandSecondary: '#D4704C',   // Deeper terracotta
  brandAccent: '#F28B66',      // Light warm coral
  brandHover: '#C84B31',       // Hover state
  brandActive: '#B43F29',      // Active/pressed state
  
  // Supporting Colors
  accentGold: '#D4A574',       // Warm gold
  accentWarm: '#FFB88C',       // Soft warm peach
  
  // Borders
  borderLight: 'rgba(200, 180, 160, 0.3)',
  borderMedium: '#E8DED3',
  borderStrong: '#C8B4A0',
  
  // Status Colors
  success: '#4CAF50',
  error: '#F44336',
  warning: '#FF9800',
  info: '#2196F3',
};

// HOW TO CHANGE COLORS:
// 1. Simply update the hex codes above
// 2. Save this file
// 3. All components will automatically use the new colors!

// QUICK THEME PRESETS (uncomment to use):

// FUSCHIA PINK THEME:
// brandPrimary: '#D946A6'
// brandHover: '#C23894'
// bgGradient: 'linear-gradient(135deg, #FFE5F5 0%, #FFDAF0 50%, #FFC9EA 100%)'

// EMERALD GREEN THEME:
// brandPrimary: '#10B981'
// brandHover: '#059669'
// bgGradient: 'linear-gradient(135deg, #D1FAE5 0%, #A7F3D0 50%, #6EE7B7 100%)'

// ROYAL BLUE THEME:
// brandPrimary: '#3B82F6'
// brandHover: '#2563EB'
// bgGradient: 'linear-gradient(135deg, #DBEAFE 0%, #BFDBFE 50%, #93C5FD 100%)'

export default colors;
